import { Map, List } from "immutable";
import { COMPANY_ACTIONS, STATE_STATUS } from "constants";

const INITIAL_GSTIN_STATE = new Map({
    status: STATE_STATUS.FETCHING,
    data: new List([]),
    error: null,
});

const INITIAL_STATE = new Map({});

export default (state = INITIAL_STATE, { type, payload, error }) => {
    switch (type) {
    case COMPANY_ACTIONS.FETCH_COMPANY_GSTIN_FILLING_DETAILS:
        return state.set(payload.gstin, INITIAL_GSTIN_STATE);
    case COMPANY_ACTIONS.FETCHED_COMPANY_GSTIN_FILLING_DETAILS:
        return state
            .setIn([payload.gstin, "status"], STATE_STATUS.FETCHED)
            .setIn([payload.gstin, "data"], new List(payload.data));
    case COMPANY_ACTIONS.FAILED_FETCH_COMPANY_GSTIN_FILLING_DETAILS:
        return state
            .setIn([payload.gstin, "status"], STATE_STATUS.FAILED_FETCH)
            .setIn([payload.gstin, "error"], error);
    case COMPANY_ACTIONS.REFRESH_COMPANY_GSTIN_FILLING_DETAILS:
        return state.setIn([payload.gstin, "status"], STATE_STATUS.UPDATING);
    case COMPANY_ACTIONS.REFRESHED_COMPANY_GSTIN_FILLING_DETAILS:
        return state
            .setIn([payload.gstin, "status"], STATE_STATUS.UPDATED)
            .setIn([payload.gstin, "data"], new List(payload.data));
    case COMPANY_ACTIONS.FAILED_REFRESH_COMPANY_GSTIN_FILLING_DETAILS:
        return state.setIn([payload.gstin, "status"], STATE_STATUS.FAILED_UPDATE);
    case "RESET_STORE":
        return INITIAL_STATE;
    default:
        return state;
    }
};
